import React, { lazy, Suspense } from "react";
import { Loader2 } from "lucide-react";

const ModelConfigPanel = lazy(
  () => import("../chatbot-v2/components/admin/ModelConfigPanel")
);

const LiftAIModels: React.FC = () => {
  return (
    <div className="w-full h-full overflow-auto">
      <div className="max-w-[1400px] mx-auto px-6 py-6 space-y-6">
        {/* Page Header */}
        <div>
          <h1 className="text-2xl font-semibold text-[#242424]">
            Lift AI Models
          </h1>
          <p className="text-sm text-[#585755] mt-1">
            Configure and manage AI models used across Lift Analysis roles and Open LLM (vanilla) mode.
          </p>
        </div>

        {/* Model Config Panel */}
        <Suspense
          fallback={
            <div className="flex items-center justify-center h-48 bg-[#F7F4F2] rounded-xl border border-[#E5E1DF]">
              <div className="flex items-center gap-3">
                <Loader2 className="h-5 w-5 animate-spin text-[#334238]" />
                <span className="text-sm text-[#585755]">
                  Loading model configuration...
                </span>
              </div>
            </div>
          }
        >
          <ModelConfigPanel />
        </Suspense>
      </div>
    </div>
  );
};

export default LiftAIModels;
